import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {ContactSalesButton} from '../../../../components/common/callToAction/contactSalesButton';
import {LearnMoreButton} from '../../../../components/common/callToAction/learnMoreButton';
import {UpsellCard} from '../../../../components/common/upsellCard/upsellCard';
import {Pill} from '../../../../components/pill/pill';

/*
 * Props.
 */

export interface AnalyticsUpsellCardProps {
  title: ReactNode;
  body: ReactNode;
  illustration: string;
  helpPage: string;
}

/*
 * Component.
 */

export const AnalyticsUpsellCard: FC<AnalyticsUpsellCardProps> = ({title, body, helpPage, illustration}) => (
  <UpsellCardWrapper>
    <UpsellCard
      title={title}
      imageUrl={illustration}
      pill={
        <Pill size={VisualSizesEnum.MEDIUM}>
          <Trans id="analytics-upsell-available-with-growth">AVAILABLE WITH GROWTH</Trans>
        </Pill>
      }
      buttons={[<ContactSalesButton />, <LearnMoreButton helpPageUrl={helpPage} />]}
    >
      {body}
    </UpsellCard>
  </UpsellCardWrapper>
);

/*
 * Styles.
 */

const UpsellCardWrapper = styled.div`
  width: 600px;
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.2));
`;
